<template>
  <v-container fluid>

    <v-layout>
      <v-flex lg12>
        <h2>{{ chartName }}</h2>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs5 md2>
        <v-menu
          :ref="'startMenu' + datasetName"
          :close-on-content-click="true"
          v-model="startMenu"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="formattedStartDate"
            label="Start Date"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="formattedStartDate"
            no-title
            :show-current="false"
            @input="updateDates()"
            scrollable
          >
          </v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs5 offset-xs2 md2 offset-md1>
        <v-menu
          :ref="'endMenu' + datasetName"
          :close-on-content-click="true"
          v-model="endMenu"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="formattedEndDate"
            label="End Date"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="formattedEndDate"
            no-title
            :show-current="false"
            @input="updateDates()"
            scrollable
          >
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 class="chart-container">
        <canvas :id="datasetName"></canvas>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { DateTime } from 'luxon';

export default {
  name: 'StackedIndustryChart',
  props: ['chartName', 'datasetName', 'updateChartData'],

  data() {
    return {
      formattedStartDate: null,
      formattedEndDate: null,
      endMenu: false,
      startMenu: false,
      dates: {}
    };
  },

  computed: {
    ...mapState('industry', ['data'])
  },

  methods: {
    ...mapActions('industry', ['setDates']),

    formatDates() {
      this.formattedStartDate = this.dates.startDate.toFormat('yyyy-LL-dd');
      this.formattedEndDate = this.dates.endDate.toFormat('yyyy-LL-dd');
    },

    updateDates() {
      this.dates = {
        startDate: DateTime.fromFormat(this.formattedStartDate, 'yyyy-LL-dd'),
        endDate: DateTime.fromFormat(this.formattedEndDate, 'yyyy-LL-dd')
      };
      this.setDates({ ...this.dates, datasetName: this.datasetName });
      this.updateChartData(this.datasetName);
    }
  },

  mounted() {
    this.dates = {
      startDate: DateTime.utc().minus({days: 10}).startOf('day'),
      endDate: DateTime.utc().startOf('day')
    };
    this.formatDates();
    this.setDates({ ...this.dates, datasetName: this.datasetName });
    this.updateChartData(this.datasetName);
  }
};
</script>

<style lang="scss" scoped>
  h2 {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .chart-container {
    height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reports/industry/StackedIndustryChart.vue